import { render, staticRenderFns } from "./CompanyListViewCard.vue?vue&type=template&id=59c68b30"
import script from "./CompanyListViewCard.vue?vue&type=script&lang=js"
export * from "./CompanyListViewCard.vue?vue&type=script&lang=js"
import style0 from "./CompanyListViewCard.vue?vue&type=style&index=0&id=59c68b30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports